import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopItemsService } from '@/modules/shop/api/services'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

type DeleteShopItemResponse = void

const useMutationDeleteShopItem = () => {
	const queryClient = useQueryClient()

	return useMutation<DeleteShopItemResponse, Error, string>({
		mutationFn: (id) => ShopItemsService.deleteShopItem(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SHOP_QUERY_KEYS.ITEMS.ALL })
			toast.success('ลบสินค้าสำเร็จ')
		},
		onError: (error) => {
			console.error('Delete shop item error:', error)
			showErrorToast(error)
		},
	})
}

export default useMutationDeleteShopItem
